export default {
    formId: 'companyForm',
    formField: {
        /******************
         * Business Details
         *****************/
        current_customer: {
            name: 'current_customer',
            label: 'Current Vodafone Customer*',
            requiredErrorMsg: 'This is required'
        },
        account_no: {
            name: 'account_no',
            label: 'Account Number'
        },
        current_mobile_no: {
            name: 'current_mobile_no',
            label: 'Existing Mobile Number'
        },
        company_name: {
            name: 'company_name',
            label: 'Company Name*',
            requiredErrorMsg: 'This is required'
        },
        trading_as: {
            name: 'trading_as',
            label: 'Trading As*',
            requiredErrorMsg: 'This is required'
        },
        abn_acn: {
            name: 'abn_acn',
            label: 'ABN/ACN'
        },
        industry_type: {
            name: 'industry_type',
            label: 'Industry Type'
        },
        account_pin: {
            name: 'account_pin',
            label: 'Account PIN'
        },
        business_type: {
            label: "Business Type",
            name: "business_type",
            options: [
                {
                    value: "corporate",
                    label: 'Corporate'
                },
                {
                    value: "local_registered",
                    label: 'Local Registered Company'
                },
                {
                    value: "company",
                    label: 'Company'
                },
                {
                    value: "trust",
                    label: 'Trust'
                },
                {
                    value: "partnership",
                    label: 'Partnership'
                }
            ]
        },
        trading_start_date: {
            name: 'trading_start_date',
            label: 'Trading Start Date'
        },
        director_name: {
            name: 'director_name',
            label: 'Name of Director'
        },
        time_in_industry: {
            label: "Time In Industry",
            fields: {
                industry_years: {
                    name: 'industry_years',
                    label: 'Years'
                },
                industry_months: {
                    name: 'industry_months',
                    label: 'Months'
                }
            }
        },
        no_of_employees: {
            name: 'no_of_employees',
            label: 'Number of Employees'
        },
        no_of_locations: {
            name: 'no_of_locations',
            label: 'Number of Locations'
        },
        current_trading_address: {
            label: "Current Trading Address",
            fields: {
                street: {
                    name: 'current_trading_address_street',
                    label: 'Street Address'
                },
                state: {
                    name: 'current_trading_address_state',
                    label: 'State'
                },
                postcode: {
                    name: 'current_trading_address_postcode',
                    label: 'Postcode'
                }
            }
        },
        time_at_current_address: {
            label: "Time At Current Address",
            fields: {
                current_trading_address_years: {
                    name: 'current_trading_address_years',
                    label: 'Years'
                },
                current_trading_address_months: {
                    name: 'current_trading_address_months',
                    label: 'Months'
                }
            }
        },
        previous_trading_address: {
            label: "Previous address, if less than 3 years at current address",
            fields: {
                street: {
                    name: 'previous_trading_address_street',
                    label: 'Street Address'
                },
                state: {
                    name: 'previous_trading_address_state',
                    label: 'State'
                },
                postcode: {
                    name: 'previous_trading_address_postcode',
                    label: 'Postcode'
                }
            }
        },
        /******************
         * Customer Details form
         *****************/
        customer_type: {
            name: "customer_type",
            options: [
                {
                    value: "decision_maker",
                    label: "Decision Maker"
                },
                {
                    value: "authorised_contact",
                    label: "Authorised Contact"
                },
                {
                    value: "attached_letter_of_authority",
                    label: "Letter of Authority Attached"
                }
            ]
        },
        title: {
            name: "title",
            label: "Title"
        },
        given_name: {
            name: "given_name",
            label: "Given Name(s)"
        },
        surname: {
            name: "surname",
            label: "Surname"
        },
        position_in_company: {
            name: "position_in_company",
            label: "Position in Company"
        },
        date_of_birth: {
            name: "date_of_birth",
            label: "Date of Birth"
        },
        email: {
            name: "email",
            label: "Email Address"
        },
        primary_contact_no: {
            name: "primary_contact_no",
            label: "Primary Contact No"
        },
        customer_contact_address: {
            label: "Contact Address",
            fields: {
                street: {
                    name: 'customer_contact_address_street',
                    label: 'Street Address'
                },
                state: {
                    name: 'customer_contact_address_state',
                    label: 'State'
                },
                postcode: {
                    name: 'customer_contact_address_postcode',
                    label: 'Postcode'
                }
            }
        },
        id1_type: {
            name: "id1_type",
            label: "ID Type"
        },
        id1_ref_no: {
            name: "id1_ref_no",
            label: "ID Ref Number"
        },
        id1_expiry_date: {
            name: "id1_expiry_date",
            label: "Expiry Date"
        },
        id2_type: {
            name: "id2_type",
            label: "ID Type"
        },
        id2_ref_no: {
            name: "id2_ref_no",
            label: "ID Ref Number"
        },
        id2_expiry_date: {
            name: "id_expiry_date",
            label: "Expiry Date"
        },
        id1a_file: {
            name: "id1a_file",
            label: "ID 1a"
        },
        id1b_file: {
            name: "id1b_file",
            label: "ID 1b"
        },
        id2_file: {
            name: "id2_file",
            label: "ID 2"
        },
        /******************
         * Billing Account Details
         *****************/
        send_email_bill: {
            name: "send_email_bill",
            label: "Email bill – A PDF bill will be emailed on a monthly basis to this email address."
        },
        bill_email: {
            name: "bill_email",
            label: "Email Address"
        },
        send_paper_bill: {
            name: "send_paper_bill",
            label: "Paper bill – A paper bill will be sent on a monthly basis to this billing address."
        },
        billing_address: {
            label: "Billing Address",
            fields: {
                street: {
                    name: 'billing_address_street',
                    label: 'Street Address'
                },
                state: {
                    name: 'billing_address_state',
                    label: 'State'
                },
                postcode: {
                    name: 'billing_address_postcode',
                    label: 'Postcode'
                }
            }
        },
        view_bill_online: {
            name: "view_bill_online",
            label: "View my bill online via www.myvodafone.com.au – I will receive a TXT notification each month to my mobile advising me that my bill is ready to view online."
        },
        debit_from_bank: {
            name: "debit_from_bank",
            label: "Direct debit from bank account"
        },
        bank_bsb_no: {
            name: "bank_bsb_no",
            label: "BSB Number"
        },
        bank_acct_no: {
            name: "bank_acct_no",
            label: "Account Number"
        },
        bank_institution: {
            name: "bank_institution",
            label: "Institution"
        },
        bank_branch: {
            name: "bank_branch",
            label: "Branch"
        },
        bank_acct_name: {
            name: "bank_acct_name",
            label: "Account Name"
        },
        debit_from_card: {
            name: "debit_from_card",
            label: "Direct debit from credit card"
        },
        card_type: {
            name: "card_type",
            label: "Credit Card Type",
            fields: {
                mastercard: {
                    name: "mastercard",
                    label: "MasterCard"
                },
                visa: {
                    name: "visa",
                    label: "VISA"
                },
                amex: {
                    name: "amex",
                    label: "AMEX"
                },
                diners: {
                    name: "diners",
                    label: "Diners"
                }
            }
        },
        card_number: {
            name: "card_number",
            label: "Credit Card Number"
        },
        cardholder_name: {
            name: "cardholder_name",
            label: "Cardholder Name"
        },
        card_expiry_date: {
            name: "card_expiry_date",
            label: "Expiry Date"
        },
        /******************
         * Are you aware form
         *****************/
        application_agreement: {
            name: "application_agreement",
            label: "Application and Agreement",
            fields: {
                approval: {
                    name: "approval",
                    label: "I understand that my application is subject to approval by Vodafone and that Vodafone may decline my application without reason."
                },
                application_by_me: {
                    name: "application_by_me",
                    label: "This is an application by me for connection(s) to the Vodafone Network and supply of a Vodafone mobile service(s)"
                },
                governed_by_terms: {
                    name: "governed_by_terms",
                    label: "If my application is accepted (and even if I am porting and my porting fails),\n" +
                        "my use of the Vodafone services governed by the terms of Vodafone’s\n" +
                        "Standard Terms available at vodafone.com.au"
                },
                application_for_purchase: {
                    name: "application_for_purchase",
                    label: "This is an application by me to purchase a Mobile Device under Vodafone’s\n" +
                        "Mobile Payment Plan. If my application is accepted, my Mobile Payment\n" +
                        "Plan is governed by the Mobile Payment Plan terms and conditions\n" +
                        "available as part of the Standard Terms at vodafone.com.au"
                },
                allow_credit_check: {
                    name: "allow_credit_check",
                    label: "Vodafone may undertake a credit check on the company and its directors " +
                        "through Equifax or Illion. We collect, use and store your personal information in accordance with the Australian Privacy Act and our Privacy " +
                        "Policy which is available on the Vodafone website. The information obtained as a result of the credit check may be used for the purpose of " +
                        "determining the application and for any other purpose permitted under the Privacy Act. I consent to my personal details being used for identity " +
                        "verification and am authorised to provide these details which will be matched to information held by the issuer or Official Record Holder?"
                },
                min_commitment_period: {
                    name: "min_commitment_period",
                    label: "My contract with Vodafone commences when my applications is accepted, however, any minimum Commitment Period will start on the date I am first " +
                        "connected to the Vodafone Network. My application will be deemed to be accepted upon my connection to the Vodafone Network."
                },
                responsible_for_due: {
                    name: "responsible_for_due",
                    label: "I agree that I am responsible for all amounts that become due in relation to this account, including, if applicable, any Early Termination Payment."
                },
                company_authorized: {
                    name: "company_authorized",
                    label: "If my application is in the name of a company, I warrant that I am authorised to sign this form on the company’s behalf."
                }
            }
        },
        plan_critical_info: {
            name: "plan_critical_info",
            label: "Plan and Critical Information Summary",
            fields: {
                plan_explained: {
                    name: "plan_explained",
                    label: "My plan features and how to contact Vodafone customer service have been explained to me. The Critical Information Summary for my plan, available " +
                        "at vodafone.com.au/cis and in store, has been explained to me and I understand that a copy will also be emailed to me."
                }
            }
        },
        contract_term: {
            name: "contract_term",
            label: "Contract Term, Early Termination Payment & Other Charges",
            fields: {
                term_charge_explained: {
                    name: "term_charge_explained",
                    label: "The term of my contract, Early Termination Payments & other charges have been explained to me."
                }
            }
        },
        network_coverage: {
            name: "network_coverage",
            label: "Network and Coverage",
            fields: {
                coverage_understood: {
                    name: "coverage_understood",
                    label: "I have discussed and understand the Vodafone Network Coverage in the areas where I require use of my service."
                },
                any_network: {
                    name: "any_network",
                    label: "I understand that Vodafone may use any network it considers appropriate to provide services to me."
                }
            }
        },
        handset_insurance: {
            name: "handset_insurance",
            label: "Handset Insurance",
            fields: {
                handset_insurance_offered: {
                    name: "handset_insurance_offered",
                    label: "Handset insurance has been offered to me and my preference is indicated on my Network Service Application."
                }
            }
        },
        aware_devices: {
            name: "aware_devices",
            label: "Devices",
            fields: {
                devices_provided: {
                    name: "devices_provided",
                    label: "I have been provided all devices that are part of the service I am signing up to today."
                },
                devices_deferred: {
                    name: "devices_deferred",
                    label: "I have selected a handset that is available on a deferred fulfilment basis, and will not receive my handset immediately."
                }
            }
        },
        aware_porting: {
            name: "aware_porting",
            label: "Porting",
            fields: {
                porting_yes: {
                    name: "porting_yes",
                    label: "I am porting my mobile number from my current supplier."
                },
                porting_date: {
                    name: "porting_date",
                    label: "I have agreed on a target date to port any numbers I will bring over from another network (if not being ported instantly). Vodafone does not warrant " +
                        "or guarantee that the listed numbers will be ported on the Target Port Date."
                }
            }
        },
        international_roaming: {
            name: "international_roaming",
            label: "International Roaming and Dialling",
            fields: {
                new_active_default: {
                    name: "new_active_default",
                    label: "If connecting to a new Vodafone Plan, international roaming and dialling will be active by default. I can opt-out at any time. I have discussed and " +
                        "understand the applicable rates and charges."
                },
                old_unchanged: {
                    name: "old_unchanged",
                    label: "If recontracting on an existing plan I understand that my international roaming settings will remain unchanged"
                }
            }
        },
        direct_debit_request: {
            name: "direct_debit_request",
            label: "Direct Debit Request",
            fields: {
                account_authorized: {
                    name: "account_authorized",
                    label: "I authorise and request Vodafone to debit my nominated account and acknowledge that by submitting this Direct Debit Request, the terms and " +
                        "conditions of the Direct Debit Request Service Agreement found online at vodafone.com.au/directdebit are binding to me."
                },
                can_cancel_debit: {
                    name: "can_cancel_debit",
                    label: "I acknowledge that I may change or cancel my Direct Debit Request by logging into MyVodafone or by calling Vodafone"
                },
                corp_card_authorized: {
                    name: "corp_card_authorized",
                    label: "(If a company utilising a corporate card) I warrant and represent that I am an authorised representative of the Company and I am able to enter into " +
                        "this Direct Debit Request Service Agreement on behalf of the Company."
                }
            }
        },
        aware_privacy: {
            name: "aware_privacy",
            label: "Privacy",
            fields: {
                privacy_accepted: {
                    name: "privacy_accepted",
                    label: "I understand that Vodafone may use or disclose personal information collected from me in accordance with Vodafone’s Privacy Policy. Vodafone " +
                        "recognises that privacy of your personal information is important. Please visit vodafone.com.au for the Privacy Policy and more information.."
                }
            }
        },
        aware_billing: {
            name: "aware_billing",
            label: "Billing",
            fields: {
                payment_terms_explained: {
                    name: "payment_terms_explained",
                    label: "Payment terms and online billing have been explained to me. I understand online billing is not available on Shared Business Plan, Shared Mobile " +
                        "Broadband and accounts with greater than 10 services."
                }
            }
        },
        /******************
         * Authorised Signatories Form
         *****************/
        customer_signature_date: {
            name: "customer_signature_date",
            label: "Date"
        },
        billing_acct_no: {
            name: "billing_acct_no",
            label: "Billing Account Number/Row ID"
        },
        representative_signature: {
            name: "representative_signature",
            label: "Vodafone Representative Signature"
        },
        representative_signature_date: {
            name: "representative_signature_date",
            label: "Date"
        },
        /******************
         * Multiple NSA Form
         *****************/
        total_no_services: {
            name: "total_no_services",
            label: "Total Number of Services"
        },
        directory_listed: {
            name: "directory_listed",
            label: "Directory Listed"
        },
        multiple_services_enabled: {
            name: "multiple_services_enabled",
            label: "There are multiple services, refer to the Multiple/Bulk NSA form"
        },
        new_connection_type: {
            name: "new_connection_type",
            label: "Connection Type",
            type: "select"
        },
        customer_username: {
            name: "customer_username",
            label: "Username",
            type: "string"
        },
        pin_no: {
            name: "pin_no",
            label: "PIN",
            type: "string"
        },
        sim_type: {
            name: "sim_type",
            label: "SIM Type",
            type: "select"
        },
        sim_no: {
            name: "sim_no",
            label: "SIM Number",
            type: "string"
        },
        imei_no: {
            name: "imei_no",
            label: "IMEI",
            type: "string"
        },
        assigned_mobile_no: {
            name: "assigned_mobile_no",
            label: "Mobile Number",
            type: "string"
        },
        will_port_current_no: {
            name: "will_port_current_no",
            label: "Port?",
            type: "yes_no"
        },
        current_prepaid: {
            name: "current_prepaid",
            label: "Prepaid",
            type: "boolean"
        },
        current_postpaid: {
            name: "current_postpaid",
            label: "Postpaid",
            type: "boolean"
        },
        current_carrier_account_number: {
            name: "current_carrier_account_number",
            label: "Losing acct. no. (Postpaid)",
            type: "string"
        },
        msn_dob: {
            name: "msn_dob",
            label: "DOB (Prepaid)",
            type: "date"
        },
        target_port_date: {
            name: "target_port_date",
            label: "Target Port Date",
            type: "date"
        },
        plan_name: {
            name: "plan_name",
            label: "Plan Name",
            type: "string"
        },
        plan_term: {
            name: "plan_term",
            label: "Term",
            type: "string"
        },
        device: {
            name: "device",
            label: "Device",
            type: "string"
        },
        mpp_total_amount: {
            name: "mpp_total_amount",
            label: "MPP Total Amount",
            type: "string"
        },
        mpp_term: {
            name: "mpp_term",
            label: "MPP Term",
            type: "string"
        },
        mpp_monthly_payment: {
            name: "mpp_monthly_payment",
            label: "MPP Monthly Payment",
            type: "string"
        },
        insurance: {
            name: "insurance",
            label: "Insurance",
            type: "yes_no"
        },
        delivery_address: {
            name: "delivery_address",
            label: "Delivery Address",
            fields: {
                street: {
                    name: 'delivery_address_street',
                    label: 'Street Address',
                    type: "string"
                },
                state: {
                    name: 'delivery_address_state',
                    label: 'State',
                    type: "string"
                },
                postcode: {
                    name: 'delivery_address_postcode',
                    label: 'Postcode',
                    type: "string"
                }
            }
        },
        special_instruction: {
            name: "special_instruction",
            label: "Special Instructions",
            type: "string"
        },
        /******************
         * Customer Understanding Form
         *****************/
        hardware_allowance: {
            name: "hardware_allowance",
            label: "Hardware Allowance"
        },
        hardware_ordered: {
            name: "hardware_ordered",
            label: "Hardware Ordered"
        },
        data_allowance: {
            name: "data_allowance",
            label: "Data Allowance"
        },
        international_calling_allowance: {
            name: "international_calling_allowance",
            label: "International Calling allowance",
            fields: {
                zone_1: {
                    name: "ica_zone_1",
                    label: "Zone 1"
                },
                zone_2: {
                    name: "ica_zone_2",
                    label: "Zone 2"
                }
            }
        },
        minimum_monthly_commitment: {
            name: "minimum_monthly_commitment",
            label: "Minimum Monthly Commitment (inc Mobile Payment Plan)"
        },
        payout_amount: {
            name: "payout_amount",
            label: ""
        },
        non_standard_offer: {
            name: "non_standard_offer",
            label: ""
        },
        cuf_approved_by: {
            name: "cuf_approved_by",
            label: "Approved By"
        },
        cuf_approve_signed: {
            name: "cuf_approve_signed",
            label: "Signed"
        },
        cuf_approve_date: {
            name: "cuf_approve_date",
            label: "Dated"
        },
        cuf_sign_date: {
            name: "cuf_sign_date",
            label: "(Date)"
        }
    }
};